//import Notiflix from 'notiflix';
import { Notify } from 'notiflix/build/notiflix-notify-aio'
import { whenCmpScreenClosed } from './CmpConsent'
// import MicroModal from 'micromodal' // es6 module

export default {
  init() {
    let whiteListed = false
    let userType = window.userType || 'guest' //lgc_global.user_data.user_type
    let bannerType // magari meglio prendere anche questo da json
    let banners_data = JSON.parse(lgc_global.banners_data)
    let alt_banner
    let elections_banner

    const markupDisposableBanner = function (data) {
      // ⚠️ TEST — rimuovere prima del deploy
      // Banner default:
      // data = {
      //   type: 'softwall',
      //   label: "Pourquoi s'abonner ?",
      //   title: 'Juste un mot avant de continuer la lecture',
      //   text: "L'an dernier, vous avez été plus de 20 millions à venir lire ces pages. Pour soutenir le travail d'une rédaction indépendante, abonnez-vous ou offrez le Grand Continent",
      //   button: {
      //     title: 'Nos offres',
      //     url: 'https://legrandcontinent.eu/fr/offre-abonnement/',
      //     target: '_self',
      //   },
      //   image:
      //     'https://legrandcontinent.eu/fr/wp-content/uploads/sites/2/2026/04/illu-abo-02.png',
      //   alignment: 'left',
      //   background_color: '#efe6d5',
      //   white_text: false,
      //   closable: true,
      //   login_txt_before: 'Déjà abonné ?',
      //   login_link_txt: 'Connectez-vous',
      //   login_link_url: 'https://legrandcontinent.eu/fr/login/',
      //   login_txt_after: '',
      // }
      // Banner alt_2026:
      // data = {
      // type: 'softwall',
      // layout: 'alt_2026',
      // alignment: 'left',
      // background_color: '#efe6d5',
      // white_text: false,
      // closable: true,
      // label: 'POURQUOI JE VOIS CE BANNER ?',
      // title:
      //   "Parce que vous n'avez pas encore un abonnement au Grand Continent",
      // text: "En vous abonnant à la revue, vous aidez à construire la première revue indépendante en Europe, vous recevez ce qu'on ne lit nulle part ailleurs (avant de le voir repris un peu partout) et vous ne reverrez plus jamais ce message.",
      // button: {
      //   title: 'À partir de 8 € / mois',
      //   url: 'https://legrandcontinent.eu/fr/offre-abonnement/',
      //   target: '_self',
      // },
      // login_txt_before: 'Déjà abonné ?',
      // login_link_txt: 'Connectez-vous',
      // login_link_url: 'https://legrandcontinent.eu/fr/login/',
      // login_txt_after: '',
      // image:
      //   'https://legrandcontinent.eu/fr/wp-content/uploads/sites/2/2026/05/banner_click.png',
      // image_mobile:
      //   'https://legrandcontinent.eu/fr/wp-content/uploads/sites/2/2026/05/banner_click.png',
      // bottom_image:
      //   'https://legrandcontinent.eu/fr/wp-content/uploads/sites/2/2026/05/cuore.png',
      // bottom_image_mobile:
      //   'https://legrandcontinent.eu/fr/wp-content/uploads/sites/2/2026/05/cuore.png',
      // bottom_text:
      //   'Le Grand Continent est une revue indépendante, sans subventions ni milliardaires. <br/>Merci aux lectrices et aux lecteurs qui la rendent possible.',
      // }
      // ⚠️ fine TEST

      switch (data.layout) {
        case 'alt_2026':
          return markupDisposableBannerAlt2026(data)
        default:
          return markupDisposableBannerDefault(data)
      }
    }

    const markupDisposableBannerDefault = function (data) {
      const markup = `<div class="disposableBanner pointer-events-none  fixed top-0 left-0 bottom-0 right-0 z-100">
        <div class="pw-backdrop bg-gradient-to-b from-transparent to-black opacity-0 transition-opacity fixed top-0 left-0 w-full h-full"></div>
        <div class="pw-content pointer-events-auto transition-all translate-y-full opacity-0 py-5 fixed bottom-0 left-0 w-full bg-grey-lightest text-${
          data.alignment
        }" ${
          data.background_color
            ? 'style="background-color:' + data.background_color + ';"'
            : ''
        }>
          <div class="px-4 lg:px-0 mx-auto max-w-[985px] relative ${
            data.white_text ? 'text-white' : ''
          }">
            <div class="relative lg:max-w-[685px]">
              <div class="relative z-1">
                <div class="font-sans tracking-wide uppercase font-bold text-sm mr-8 ${
                  data.white_text ? 'text-white' : 'text-red'
                }">${data.label}</div>
                <h3 class="font-display font-semibold text-2xl md:text-3xl mt-4">${
                  data.title
                }</h3>
                <div class="font-sans text-sm md:text-l pr-24 md:pr-40 lg:pr-8 mt-2 mb-4">${
                  data.text
                }</div>
                  ${
                    data.button
                      ? `<a href="${data.button.url}" target="${
                          data.button.target
                        }" class="redirect_btn  ${
                          data.white_text
                            ? 'btn-outline btn-outline-white'
                            : 'btn-red'
                        } md:min-w-[345px]">${data.button.title}</a>`
                      : ''
                  }
                  <br/><span class='inline-block font-sans mt-4'>
                  ${data.login_txt_before ? data.login_txt_before : ''}
                  ${
                    data.login_link_txt
                      ? `
                  <a class='banner-login-btn text-red' href='${data.login_link_url}'>
                    ${data.login_link_txt}
                  </a> `
                      : ''
                  }
                  ${data.login_txt_after ? data.login_txt_after : ''}
                </span>
              </div>
              ${
                data.image
                  ? `<img src="${data.image}" class="absolute right-0 lg:right-auto lg:left-full bottom-20 lg:bottom-1/2 translate-y-1/2 w-[90px] h-[90px] md:w-[170px] md:h-[170px] object-contain mix-blend-multiply"/>`
                  : ''
              }              
            </div>
            <div id="close-banner-btn" class="absolute p-4 right-2 -top-4 cursor-pointer z-10 ${
              data.white_text ? 'text-black' : 'text-red'
            }">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" width="15" height="14">
                  <path d="M 1.3710938 0 L 0 1.4570312 L 6.296875 7.3789062 L 0 13.300781 L 1.3710938 14.757812 L 7.7578125 8.7519531 L 14.142578 14.757812 L 15.513672 13.300781 L 9.2167969 7.3789062 L 15.513672 1.4570312 L 14.142578 0 L 7.7578125 6.0058594 L 1.3710938 0 z " />
              </svg>
            </div>
          </div>
        </div>
        </div>`
      return markup
    }

    const markupDisposableBannerAlt2026 = function (data) {
      return `<div class="disposableBanner pointer-events-none fixed top-0 left-0 bottom-0 right-0 z-100">
        <div class="pw-backdrop bg-gradient-to-b from-transparent to-black opacity-0 transition-opacity fixed top-0 left-0 w-full h-full"></div>
        <div class="pw-content pointer-events-auto transition-all translate-y-full opacity-0 py-5 fixed bottom-0 left-0 right-0 w-full bg-[#F7EDE3] text-${data.alignment}" ${data.background_color ? 'style="background-color:' + data.background_color + ';"' : ''}>
          <div class="max-w-[1100px] mx-auto px-4 xl:px-0">
            <div class="relative flex flex-col lg:flex-row items-center gap-8">

              <div class="lg:w-2/3 ${data.white_text ? 'text-white' : ''}">
                <div class="font-sans tracking-wide uppercase font-bold text-2xs lg:text-sm">
                  ${data.label}
                </div>
                <h3 class="font-display font-semibold text-md md:text-3xl mt-2">
                  ${data.title}
                </h3>
                <div class="font-sans text-sm md:text-base mt-2 mb-4 text-grey-800">
                  ${data.text}
                </div>
                ${data.button ? `<a href="${data.button.url}" target="${data.button.target}" class="lg:mt-2 redirect_btn ${data.white_text ? 'btn-outline btn-outline-white' : 'btn-red'}">${data.button.title}</a>` : ''}
                <br/>
                <span class="inline-block font-sans text-xs mt-2 text-grey-800">
                  ${data.login_txt_before ? data.login_txt_before : ''}
                  ${data.login_link_txt ? `<a class="banner-login-btn text-red font-bold" href="${data.login_link_url}">${data.login_link_txt}</a>` : ''}
                  ${data.login_txt_after ? data.login_txt_after : ''}
                </span>
                ${data.image_mobile ? `<img src="${data.image_mobile}" class="hidden lg:hidden max-w-[140px]"/>` : ''}
                ${
                  data.bottom_text
                    ? `<div class="flex items-start gap-1 mt-3">
                  ${data.bottom_image ? `<img src="${data.bottom_image}" class="hidden lg:block flex-none" width="26"/>` : ''}
                  ${data.bottom_image_mobile ? `<img src="${data.bottom_image_mobile}" class="lg:hidden flex-none" width="26"/>` : ''}
                  <p class="flex-1 font-sans text-2xs">${data.bottom_text}</p>
                </div>`
                    : ''
                }
              </div>

              <div class="hidden lg:block lg:w-1/3">
                ${data.image ? `<img src="${data.image}" class="w-full max-w-[320px] ml-auto"/>` : ''}
              </div>

              <div id="close-banner-btn" class="absolute p-4 pr-0 pt-0 right-0 top-0 cursor-pointer z-10">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" width="15" height="14">
                  <path d="M 1.3710938 0 L 0 1.4570312 L 6.296875 7.3789062 L 0 13.300781 L 1.3710938 14.757812 L 7.7578125 8.7519531 L 14.142578 14.757812 L 15.513672 13.300781 L 9.2167969 7.3789062 L 15.513672 1.4570312 L 14.142578 0 L 7.7578125 6.0058594 L 1.3710938 0 z"/>
                </svg>
              </div>

            </div>
          </div>
        </div>
      </div>`
    }

    const markupFixBanner = function (data) {
      const markup = `<div id="fix-pw" class="pointer-events-none fixed top-0 left-0 right-0 bottom-0 z-100">
          <div class="pw-backdrop bg-gradient-to-b from-transparent to-black opacity-0 transition-opacity fixed top-0 left-0 w-full h-full"></div>
          <div class="pw-content pointer-events-auto transition-all translate-y-full opacity-0 py-10 fixed bottom-0 left-0 w-full bg-grey-lightest text-${
            data.alignment
          }" ${
            data.background_color
              ? 'style="background-color:' + data.background_color + ';"'
              : ''
          }> 
            <div class="px-4 lg:px-0 mx-auto max-w-[985px] relative ${
              data.white_text ? 'text-white' : ''
            }">
              <div class="relative">
                ${
                  data.image
                    ? `<img src="${data.image}" class="lg:absolute lg:left-9/10 xl:left-full bottom-1/2 lg:translate-y-1/2 w-[80px] h-[80px] lg:w-[170px] lg:h-[170px] mx-auto mb-4 lg:mb-0 object-contain mix-blend-multiply"/>`
                    : ''
                }
                <div class="relative z-1">
                    <div class="font-sans tracking-wide uppercase font-bold text-sm mr-8 ${
                      data.white_text ? 'text-white' : 'text-red'
                    }">${data.label}</div>
                    <h3 class="font-display font-semibold text-2xl md:text-3xl mt-4 lg:mt-10">${
                      data.title
                    }</h3>
                    <div class="font-sans text-sm md:text-l mt-4 mb-8 max-w-[570px] mx-auto">${
                      data.text
                    }</div>
                    ${
                      data.button
                        ? `<a href="${data.button.url}" target="${
                            data.button.target
                          }" class="redirect_btn ${
                            data.white_text
                              ? 'btn-outline btn-outline-white'
                              : 'btn-red'
                          } md:min-w-[345px]">${data.button.title}</a>`
                        : ''
                    }
                    <br/><span class='inline-block font-sans mt-4'>
                      ${data.login_txt_before ? data.login_txt_before : ''}
                      ${
                        data.login_link_txt
                          ? `
                      <a class='banner-login-btn text-red' href='${data.login_link_url}'>
                        ${data.login_link_txt}
                      </a> `
                          : ''
                      }
                      ${data.login_txt_after ? data.login_txt_after : ''}
                    </span>
                </div>               
              </div>
            </div>
          </div>
        </div>`
      return markup
    }
    const getBannerData = function (user, type) {
      //console.log(banners_data);
      if (banners_data) {
        for (var x = 0; x < banners_data.length; x++) {
          var curitem = banners_data[x]
          if (curitem.type == type && curitem.user == user) {
            return curitem
          }
        }
      }
      //ERROR No banner FOund:
      console.log('No banner was found for: ' + user + '_' + type)
    }
    const setCookie = function (cname, cvalue, exdays) {
      const d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }
    const getCookie = function (cname) {
      let name = cname + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }

    // let triggerBlock = (entries, observer) => {
    //   entries.forEach((entry) => {
    //     console.log(entry.target)
    //     // Each entry describes an intersection change for one observed
    //     // target element:
    //     //   entry.boundingClientRect
    //     //   entry.intersectionRatio
    //     //   entry.intersectionRect
    //     //   entry.isIntersecting
    //     //   entry.rootBounds
    //     //   entry.target
    //     //   entry.time
    //   })
    //   if (document.getElementById('fix-pw')) {
    //     document.getElementById('fix-pw').classList.add('pw-show')
    //   }
    // }
    // let options = {
    //   //      root: document.querySelector('.article-body'),
    //   rootMargin: '0px',
    //   threshold: 1.0,
    // }

    // let observer = new IntersectionObserver(triggerBlock, options)
    // let target = document.querySelector('.wp-block-lgc-keypoints')
    // observer.observe(target)

    let lastKnownScrollPosition = 0
    let ticking = false

    //let triggerPos = 1100
    let triggerEl = document.getElementById('customTriggerPos')
    let triggerPos = triggerEl ? parseInt(triggerEl.dataset.pos, 10) : 1100

    let firstIframe = document.querySelector('.iframe-container')
    let keypoints = document.querySelector('.keys')
    if (firstIframe) {
      console.log('FF')
      triggerPos = firstIframe.getBoundingClientRect().bottom
    } else if (keypoints) {
      console.log('KP')
      triggerPos = keypoints.getBoundingClientRect().top
    }
    console.log('--')
    //alert(bannerType)
    const showPaywallOnScroll = function (e) {
      lastKnownScrollPosition = window.scrollY
      //console.log(lastKnownScrollPosition)
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (lastKnownScrollPosition > triggerPos) {
            window.removeEventListener('scroll', showPaywallOnScroll)
            document.getElementById('fix-pw').classList.add('pw-show')
            var style = document.createElement('style')
            style.innerHTML = `
              .pw {
              height:${Math.round(triggerPos + 700)}px !important;
              }
              `
            document.head.appendChild(style)
            window.dataLayer.push({
              event: 'PaywallViews',
              paywallType: 'paywall',
            })
            document
              .querySelector('.pw-content .redirect_btn')
              .addEventListener('click', function () {
                window.dataLayer.push({
                  event: 'ClickSubscribe',
                  origin: 'paywall',
                })
                return true
              })
          }
          ticking = false
        })
        ticking = true
      }
    }
    const createBanner = function (userType, bannerType) {
      if (!userType || !bannerType) return
      let data = window.evBannersData
      console.log(data, ' DATA RECEIVED')
      let banner = null
      if (data) {
        banner =
          bannerType == 'paywall'
            ? markupFixBanner(data)
            : markupDisposableBanner(data)
        attachBanner(banner, bannerType)
      }
    }
    // The softwall pops up on its own, so it must not stack under the CMP
    // consent screen. Everything else answers a click (paywall included).
    const attachBanner = function (banner, bannerType) {
      if (bannerType !== 'softwall') {
        renderBanner(banner, bannerType)
        return
      }
      whenCmpScreenClosed().then(() => renderBanner(banner, bannerType))
    }
    const renderBanner = function (banner, bannerType) {
      document.querySelectorAll('.disposableBanner').forEach((element) => {
        element.remove()
      })

      switch (bannerType) {
        case 'paywall':
          document.body.classList.add('pw')
          // document
          //   .getElementsByClassName('full-article')[0]
          //   .classList.add('full-article-r')
          //window.scrollTo({top: 0, behavior: 'auto' });
          document.body.insertAdjacentHTML('beforeend', banner)
          document.addEventListener('scroll', showPaywallOnScroll)
          break
        case 'softwall':
          document.body.insertAdjacentHTML('beforeend', banner)
          document
            .getElementById('close-banner-btn')
            .addEventListener('click', function () {
              setCookie('swc', 'true', 1)
              document.body.classList.remove('db-show')
              window.dataLayer.push({
                event: 'ClickClosePayWall',
                paywallType: 'softwall',
              })
            })
          document
            .querySelector('.pw-content .redirect_btn')
            .addEventListener('click', function () {
              window.dataLayer.push({
                event: 'ClickSubscribe',
                origin: 'softwall',
              })
              return true
            })
          window.setTimeout(() => document.body.classList.add('db-show'), 1500) //per farlo apparire con animazione
          window.dataLayer.push({
            event: 'PaywallViews',
            paywallType: 'softwall',
          })
          break
        case 'save':
          document.body.insertAdjacentHTML('beforeend', banner)
          document
            .getElementById('close-banner-btn')
            .addEventListener('click', function () {
              document.body.classList.remove('db-show')
              window.dataLayer.push({
                event: 'ClickClosePayWall',
                paywallType: 'save',
              })
            })
          document
            .querySelector('.pw-content .redirect_btn')
            .addEventListener('click', function () {
              window.dataLayer.push({
                event: 'ClickSubscribe',
                origin: 'save',
              })
              return true
            })
          window.setTimeout(() => document.body.classList.add('db-show'), 10) //per farlo apparire con animazione
          window.dataLayer.push({
            event: 'PaywallViews',
            paywallType: 'save',
          })
          break
        case 'pdf':
          document.body.insertAdjacentHTML('beforeend', banner)
          document
            .getElementById('close-banner-btn')
            .addEventListener('click', function () {
              document.body.classList.remove('db-show')
              window.dataLayer.push({
                event: 'ClickClosePayWall',
                paywallType: 'pdf',
              })
            })
          document
            .querySelector('.pw-content .redirect_btn')
            .addEventListener('click', function () {
              window.dataLayer.push({
                event: 'ClickSubscribe',
                origin: 'pdf',
              })
              return true
            })
          window.setTimeout(() => document.body.classList.add('db-show'), 10) //per farlo apparire con animazione
          window.dataLayer.push({
            event: 'PaywallViews',
            paywallType: 'pdf',
          })
          break
      }

      // MicroModal.init({ disableFocus: true })

      // document.body.addEventListener('click', (event) => {
      //   if (event.target.matches('.banner-login-btn')) {
      //     event.preventDefault()
      //     MicroModal.show('login-modal')
      //   }
      // })

      //show pawallBanner
      //show pdf banner
      //show save banner
      //show softwall banner
    }
    const initPaywall = function () {
      //alert('init paywall')
      bannerType = window.bannerType
      createBanner(userType, bannerType)
    }
    const initDisabledBtns = function () {
      let elements = document.querySelectorAll('.savePostDisabled')
      elements.forEach((element) => {
        element.addEventListener('click', (event) => {
          window.dataLayer.push({
            event: 'save_favorite',
            subscribed: 'no',
          })
          createBanner(userType, 'save')
        })
      })
      elements = document.querySelectorAll('.generatePdfDisabaled')
      elements.forEach((element) => {
        element.addEventListener('click', (event) => {
          window.dataLayer.push({
            event: 'DownloadPDF',
            subscribed: 'no',
          })
          createBanner(userType, 'pdf')
        })
      })

      const standard_downloads = document.querySelectorAll(
        '.u-registered .wp-block-file .wp-block-file__button[download], .u-guest .wp-block-file .wp-block-file__button[download], .u-registered .wp-block-file a, .u-guest .wp-block-file a'
      )
      standard_downloads.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          createBanner(userType, 'pdf')
        })
      })
    }

    // init tasto pdf
    let promise = new Promise(function (resolve, reject) {
      //setTimeout(() => resolve("done!"), 1000);
      // setTimeout(() => reject(new Error("Whoops!")), 1000);
    })
    // resolve runs the first function in .then
    promise.then(
      (result) => alert(result), // shows "done!" after 1 second
      (error) => alert(error) // doesn't run
    )

    // init tasto salva

    // inizializzo paywall o softwall
    // if (window.bannerType) {
    //   bannerType = window.bannerType
    //   initPaywall()
    //   //initDisabledBtns()
    // } else {
    //   document.addEventListener('evolokRender', (e) => {
    //     console.log('Evolok paywall event triggered' + e)
    //     console.log(window.evBannersData)
    //     console.log(evBannersData)
    //     setTimeout(() => {
    //       console.log(window.evBannersData)
    //     }, 500)
    //     bannerType = window.bannerType
    //     initPaywall()
    //     //initDisabledBtns()
    //   })
    // }
    document.addEventListener('evJsBannerReady', (e) => {
      console.log('Evolok paywall JS event triggered' + e)
      window.evBannersData = e.detail
      bannerType = window.bannerType
      initPaywall()

      // console.log(window.evBannersData)
      // console.log(evBannersData)
    })
  },
}
